<template>
  <div>
    <label class="section-title -strong -mb">General &amp; Matchers</label>

    <input v-model="editableLabel" type="text" placeholder="Label" @input="emitChange" />
    <span v-if="labelError()" class="alert -inline -danger">Label {{ labelError() }}</span>

    <label>
      <input v-model="editableMatcherType" type="radio" value="and" @change="emitChange" />
      <strong>And</strong>: All matchers must pass
    </label>
    <label>
      <input v-model="editableMatcherType" type="radio" value="or" @change="emitChange" />
      <strong>Or</strong>: One matcher must pass
    </label>

    <hr />

    <div v-for="(matcher, index) in editableMatchers" :key="index" class="quarters">
      <!--
      --><select v-model="matcher.input" @change="emitChange">
        <option value="message">Message</option>
        <option value="context">Context</option>
        <option value="customer">Customer</option></select
      ><!--

      --><input
        v-if="matcher.input === 'context'"
        v-model="matcher.field"
        type="text"
        placeholder="Field"
        @input="emitChange"
      /><!--

      --><select v-model="matcher.type" @change="emitChange">
        <option v-if="matcher.input === 'message' || matcher.input === 'context'" value="regex">Matches</option>
        <option v-if="matcher.input === 'message'" value="contains_phone_number">Contains phone number</option>
        <option v-if="matcher.input === 'message'" value="contains_email_address">Contains email address</option>
        <option v-if="matcher.input === 'message'" value="is_confirmation">Is confirmation</option>
        <option v-if="matcher.input === 'message'" value="queried_time">Queried time</option>
        <option v-if="matcher.input === 'message'" value="prefers_email">Prefers Email</option>
        <option v-if="matcher.input === 'context'" value="is_truthy">Is truthy</option>
        <option v-if="matcher.input === 'context'" value="greater_than">Is greater than</option>
        <option v-if="matcher.input === 'context'" value="less_than">If less than</option></select
      ><!--

      --><input
        v-if="['contains', 'regex', 'greater_than', 'less_than'].includes(matcher.type)"
        v-model="matcher.options"
        type="text"
        placeholder="Options"
        @input="emitChange"
      /><!--

      --><span v-if="matcher.options.length === 0 && matcherError()" class="alert -inline -danger"
        > {{ matcherError() }}</span
      ><!--

      --><br /><a href="#" class="button -danger -small" @click.prevent="removeMatcher(matcher)">Remove this matcher</a>

      <hr />
    </div>

    <a href="#" class="button -small" @click.prevent="addMatcher">Add a matcher</a>
  </div>
</template>

<script>
import dig from "object-dig";
import _ from "underscore";

export default {
  name: "QueryGeneral",

  props: {
    query: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      required: true
    }
  },

  emits: ["change"],

  data() {
    return {
      editableLabel: "",
      editableMatcherType: "and",
      editableMatchers: [],
      editableErrors: {}
    };
  },

  watch: {
    query(newQuery, oldQuery) {
      // Only reset if loading different query (by ID change)
      // Don't reset if editing the same query
      if (!oldQuery || oldQuery.id !== newQuery.id) {
        this.setEditableFields();
      }
    },

    errors() {
      this.editableErrors = this.errors;
    }
  },

  mounted() {
    this.setEditableFields();
  },

  methods: {
    labelError() {
      if (this.editableErrors.label) {
        return this.editableErrors.label[0];
      }

      if (this.editableErrors.unique_label) {
        return this.editableErrors.unique_label[0];
      }

      return null;
    },

    matcherError() {
      const errors = dig(this.editableErrors, "matchers");
      if (errors) { return errors.join('. '); }
    },

    addMatcher() {
      this.editableMatchers.push({ input: "message", field: "", type: 'regex', options: "" });
      this.emitChange();
    },

    removeMatcher(matcher) {
      this.editableMatchers = _.without(this.editableMatchers, matcher);
      this.emitChange();
    },

    emitChange() {
      const changeData = {
        label: this.editableLabel,
        matcher_type: this.editableMatcherType,
        matchers: this.editableMatchers,
      };
      this.$emit("change", changeData);
    },

    change() {
      this.emitChange();
    },

    setEditableFields() {
      this.editableLabel = dig(this.query, "label") || "";
      this.editableMatcherType = dig(this.query, "matcher_type") || "and";
      const matchers = dig(this.query, "matchers") || [];
      this.editableMatchers = JSON.parse(JSON.stringify(matchers));
    }
  }
};
</script>
